import "./MetricsCard.scss";
import { useState, useEffect } from "react";
import Loader from "../Loader/Loader";

const MetricsCard = ({
  title,
  date = null,
  value,
  change,
  changeLabel,
  activeMetricsCard,
  setActiveMetricsCard,
  metricsLoading,
  align = "left",
  isDate = false,
}) => {
  const [isLoading, setIsLoading] = useState(metricsLoading);

  useEffect(() => {
    setIsLoading(metricsLoading);
  }, [metricsLoading]);

  return (
    <div
      className={`rounded-1 p-3 ${
        activeMetricsCard ? "active-metrics-card" : "border"
      }
      ${align === "center" ? "metric-card-center" : ""}
      ${
        setActiveMetricsCard 
        // && title !== "On Funder Portal"
          ? "cursor-pointer"
          : ""
      }`}
      onClick={() =>
        setActiveMetricsCard &&
        // title !== "On Funder Portal" &&
        setActiveMetricsCard()
      }
    >
      <div
        className={`d-flex ${date ? "justify-content-between" : align === "center" ? "justify-content-center" : ""}`}
      >
        <h5 className="">{title}</h5>
        {date && <span className="text-black-50">{date}</span>}
      </div>

      {!isLoading ? (
        <div
          className={`d-flex align-items-baseline ${
            change && change !== "NA"
              ? "justify-content-between"
              : isDate
                ? "justify-content-start"
                : change === "NA"
                  ? "justify-content-between"
                  : "justify-content-center"
          }`}
        >
          {isDate ? (
            <h5 className="fw-bolder text-muted">{value}</h5>
          ) : (
            <h3 className="fw-bolder text-muted">{value}</h3>
          )}

          {change && change !== "NA" && (
            <span className="">
              <span className="text-success">{change}</span>
              <span className="text-black-50"> {changeLabel}</span>
            </span>
          )}

          {change === "NA" && <span className=""></span>}
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default MetricsCard;
